import React from 'react';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import MobileView from './Viewports/MobileView';
import DesktopView from './Viewports/DesktopView';
import SplitHero from './SplitHero';
import { usePageDataContext } from '~/context/PageData';

export function FullwidthHero(props: IFullwidthHero20Fields) {
  const { isReturning } = usePageDataContext();

  return (
    <>
      {props.useAltLayout ? (
        <SplitHero {...props} isReturning={isReturning} theme={props.theme} />
      ) : (
        <>
          <DesktopView {...props} isReturning={isReturning} />
          <MobileView {...props} isReturning={isReturning} />
        </>
      )}
    </>
  );
}
